<template>
  <div class="lv-user-card">
    <LlAvatar :image="image" :circleSize="88" />
    <LvText h3 bold class="mt-16">{{ name }}</LvText>
    <LvText wrap blue remark class="mt-8">{{ email }}</LvText>
    <div class="lv-user-card__toggle" :class="{ hidden: isToggle }">
      <LvText h6 bold class="mt-16">{{ $t('我的角色') }}</LvText>
      <LvText v-for="(titleItem, titleIndex) in title" :key="titleIndex" h6 lightGray class="mt-8">
        <span v-if="titleIndex > 0">・</span>
        {{ titleItem }}
      </LvText>
      <LvText h6 bold class="mt-16">{{ $t('我的限閱領域') }}</LvText>
      <div class="chip-list">
        <ContentChip
          v-for="(chip_e, chip_k) in systemField"
          :key="chip_k"
          :textLabel="chip_e"
          bold
          yellow
          class="mt-4"
        />
      </div>
    </div>
    <div v-if="_showToggleBtn" class="toggle-btn" @click="isToggle = !isToggle">
      <i :class="{ show: isToggle }" class="icon-chevron-up toggle-btn__icon" />
      {{ $t(_toggleBtnName) }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    image: {
      type: String,
    },
    name: {
      type: String,
    },
    email: {
      type: String,
    },
    title: {
      type: Array,
      default() {
        return [];
      },
    },
    systemField: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isToggle: true,
    };
  },
  computed: {
    _toggleBtnName() {
      return this.isToggle ? '展開角色及領域' : '收起角色及領域';
    },
    _showToggleBtn() {
      return this.title.length > 5 || this.systemField.length > 5;
    },
  },
};
</script>
